import {
  Box, Checkbox, FormControlLabel, FormGroup, Grid, Typography,
} from '@mui/material';
import LimiterInput from './LimiterInput';
import { InputLimits } from '../../../../enums/InputLimits';

function GoogleAnalyticsSetting(props: {
  googleAnalyticsScript: string,
  isRobotsNoindex: boolean,
  onGoogleAnalyticsScriptChange: (value: string) => void,
  onIsRobotsNoindexChange: (value: boolean) => void,
}) {
  const {
    googleAnalyticsScript,
    isRobotsNoindex,
    onGoogleAnalyticsScriptChange,
    onIsRobotsNoindexChange,
  } = props;

  return (
    <Box display="flex" flexDirection="column" rowGap="10px">
      <Box>
        <h2 className="mb-2">Google Analytics関連</h2>
      </Box>
      <Box className="pb-2">
        <hr className="mt-4" />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LimiterInput
              textarea
              label="GA4用のトラッキングコード"
              limit={InputLimits.GA4_SCRIPT}
              value={googleAnalyticsScript || ''}
              onChange={(newValue) => onGoogleAnalyticsScriptChange(newValue)}
              placeholder="トラッキングコードのタグは</head>の直前に埋め込みされます。"
            />

            <Typography variant="caption">
              ※Googleアナリティクス上に表示された、GA4用のトラッキングコードをコピーしてください。
            </Typography>
          </Grid>
        </Grid>
        <hr className="mt-4" />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" className="text-bold mb-2">
              検索エンジン
            </Typography>
            <FormGroup>
              <FormControlLabel
                control={(
                  <Checkbox
                    size="small"
                    checked={isRobotsNoindex}
                    onChange={(e) => onIsRobotsNoindexChange(e.target.checked)}
                  />
                )}
                label="検索エンジンに表示させないようにする"
                sx={{
                  '& .MuiFormControlLabel-label': { fontSize: '14px' },
                }}
              />
            </FormGroup>
            <Typography variant="caption" style={{ lineHeight: '0' }}>
              ※Googleなどの検索エンジンにインデックスされないようにします。
              <br />
              ※noindexを追加します。
              <br />
              {'　追加タグ：<meta name=”robots” content=”noindex”>'}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default GoogleAnalyticsSetting;
